export default __webpack_public_path__ + "static/media/Earrings.bc109e26.jpg";